import React from 'react';
import { connect } from  'react-redux';
import { Redirect, Link } from 'react-router-dom';
import {api} from '../../actions/_request';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

// styling
import './style.css';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';

import {
    AreaChart, Area, BarChart, Bar,
    PieChart, Pie,
    XAxis, YAxis, CartesianGrid, Tooltip, Legend, Cell, Sector,
    ResponsiveContainer
} from 'recharts';

import _ from 'underscore';

import ReporteComisiones from './reporteComisiones';
import Ventas from './ventasEspeciales';
import EntregasDiarias from './entregasDiarias';
import Sinpv from './reportessinpv';
import ParticipacionesContpaq from './participacionesContpaq'
import Lista_tickets from './lista_tickets'
import Utilidadcategoria from './utilidad_categoria'
import BanlanceGeneral from './balance_general'
import ReporteComiosionesGeneral from './reporteComicionesGeneral'
import CumplimientoCitas from './cumplimientocitas';
import TicketsCancelados from './ticketsCancelados';
import TicketsNoAprobados from './ticketsNoAprobados';
import DistribucionParticipaciones from './DistribucionParticipaciones';
import TicketsGeneral from './reporteticketsgeneral'
import Reporteproduccion from './reporte_produccion_validar';
//icons
import FAfloppyO from 'react-icons/lib/fa/floppy-o';
import FAchevronleft from 'react-icons/lib/fa/chevron-left';
import Fasearch from 'react-icons/lib/fa/search';
import * as actions from '../../actions/user';
const {PropTypes} = React;

const CustomTooltip  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      // console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : $${new Intl.NumberFormat().format(item.value)}`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});

const CustomTooltip2  = React.createClass({
  propTypes: {
    type: PropTypes.string,
    payload: PropTypes.array,
    label: PropTypes.string,
  },

  render() {
    const { active } = this.props;
    if (active) {
      const { payload, label,fill } = this.props;
      // style={{width: '100%', height: '280px'}}
      // console.log('propiedades grafica--->',this.props);
      return (
        <div className="custom-tooltip">
				{
				  payload.map((item, i) => 
				  <p className="label text-capitalize" style={{ 'color': ''+item.fill }} >{`${item.name} : ${item.value} %`}</p>
				  )
				}
                         
        </div>
      );
    }
    return null;
  }
});
const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

const anos = [
	{label : '2018' , value :2018},
	{label : '2019', value :2019},
	{label : '2020', value :2020},
];



const departamentos = [
	{label: 'Ventas', value: 1},
	{label: 'Contpaq', value: 2},
	{label: 'Remanufacturado', value: 3},
	{label: 'Tecnico', value: 4},
	{label: 'Instalaciones', value: 5}
];

const tipos = [
    {label: 'Todos', value: 0},
	{label: 'Tienda', value: 1},
	{label: 'Sitio', value: 2},
	{label: 'Remoto', value: 3},
	{label: 'Venta', value: 4}
];


class Reportes extends React.Component
{
	constructor(props){
		super(props)

		var fecha = new Date( moment().format('Y-MM-DD')+'T12:00:00Z');
				
				// console.log('Fecha--->',fecha);
				//  console.log('mes--->',fecha.getMonth()+1);
				//  console.log('mes--->',fecha.getFullYear());

		this.state = {
			reporte : {
				reporte_id : '',
				fecha_1 : moment().format('Y-MM-DD'),
				fecha_2 : moment().add(1, 'days').format('Y-MM-DD'),
				filtro_2 : '',
				user_id : 0,
				tipo_id:0,
				mes:(fecha.getMonth()+1),
			    ano:(fecha.getFullYear()),

			},
			data:[],
			usuarios : [],
			urlreporte:"",
			urlreporte2:"",
			routeEntrega : "",
			routesinpv:'',
			reporte_contpaq:'',
			urlcategoria:'',
			urlcumplimiento:'',
			categorias:[],


			cliente : null,
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.search = this.search.bind(this);
		this.filter = this.filter.bind(this);

	}

	componentDidMount(){
       let reporte = this.state.reporte;
		let self = this;
		api().get('/select/users')
        .then(function(response)
        {
            let usuarios = response.data;
            usuarios.unshift(
            	{value:0,
            		label:'Todos'});
        	api().get('/categorias')
	        .then(function(response)
	        {
	        	reporte.categoria=response.data[0].value;
	            self.setState({
	                usuarios : usuarios,
	                categorias:response.data,
	                reporte : reporte,
	            });
	            // console.log(response)
	           
	        });
           
        });
	}

	handleInputChange(event) {

		if(event === null) return;

		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		// console.log(name)
		// console.log(value)

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},

                urlreporte : "",
                urlreporte2 : "",
                routeEntrega : '',
                routesinpv:'',
                reporte_contpaq:'',
                urlcategoria:'',
                urlcumplimiento:'',

           
		});

	}

	handleSelectChange(select, name) {

		const value = select === null ? null : select.value;
		let banlance_general=false;
		if(name=='reporte_id'){
			if(parseInt(value)==11)
				banlance_general=true;
		}

		this.setState({
			reporte: {
				...this.state.reporte,
				[name]: value
			},
			urlreporte : "",
            urlreporte2 : "",
            routeEntrega : '',
            routesinpv:'',
            reporte_contpaq:'',
            urlcategoria:'',
            banlance_general:banlance_general,
		});

		if(name === 'user_id'){
			this.cliente = select;
		}
	}

	// getClients(input, callback) {

	// 	if(input != '') {

	// 		api().get('/select/users', { params: {search: input} }).then(function(response) {

	// 			callback(null, {
	// 				options: response.data,
	// 				complete: true
	// 			});

	// 		});

	// 	}
	// 	else {
	// 		callback(null, {
	// 			options: [],
	// 			complete: true
	// 		});
	// 	}

	// }

	search(){
		let {reporte } = this.state;

		let route ="/reporte"

		let self = this;
		switch(reporte.reporte_id){
			case 1: 
				route += "/produccionindividual/"+ reporte.user_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				break;
			case 2: 
				route += "/produccion/"+reporte.fecha_1 + "/" + reporte.fecha_2;
				break;
			case 3: 
				route += "/garantia/" + reporte.fecha_1 + "/" + reporte.fecha_2;

				break;
			case 4: 
				route +=  "/cumplimiento/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				self.setState({
                urlcumplimiento : route
            });
				break;
			case 5: 
				route += "/comisiones/"+ reporte.user_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				 self.setState({
                urlreporte : route
            });
				 route ="/reporte";


				break;
			case 6: 
				var user=reporte.user_id;
				if(user === '' || user === null)
				{
					user=0;
				}
				route += "/ventas_especiales/"+ user + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				 self.setState({
                	urlreporte2 : route
            	});

				 route ="/reporte";
				 // console.log("entro");


				break;
			case 7:
				route += "/entregas_diarias/"+reporte.fecha_1;
				self.setState({
                	routeEntrega : route
            	});
				break;
				case 8:
				route += "/tickets_sinpv/"+reporte.tipo_id + "/" +reporte.fecha_1 + "/" + reporte.fecha_2;
				self.setState({
                	routesinpv : route
            	});
				break;
				case 9:
				var fecha = new Date(reporte.fecha_1+'T12:00:00Z');
				// console.log('Fecha state--->',reporte.fecha_1);
				// console.log('Fecha--->',fecha);
				//  console.log('mes--->',fecha.getMonth()+1);
				//  console.log('mes--->',fecha.getFullYear());
				
				route += "/contpaq/"+(reporte.mes)+"/"+reporte.ano;
				self.setState({
                	reporte_contpaq : route
            	});
				break;
				case 10:
				route += "/utilidad/tickets/categoria/1/"+(reporte.categoria)+"/"+(reporte.mes)+"/"+reporte.ano;
				self.setState({
                	urlcategoria : route
            	});
				break;

		}
		
		if(route !== "/reporte" && reporte.reporte_id !== 7){
		api().get(route)
        .then(function(response)
        {
            self.setState({
                data : response.data
            });
            // console.log(response.data)
        });
    }


	}

	filter(evt){

		let {reporte} = this.state;
		let route ="/reporte"
		// console.log(reporte.reporte_id);

		let self = this;
		switch(reporte.reporte_id){
			case 1: 

				break;
			case 2: 
			if(evt.estado == 'departamento'){
					route += "/produccion/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/produccion_departamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}

				break;
			case 3: 
				if(evt.estado == 'individual'){
					route += "/garantia/" + reporte.fecha_1 + "/" + reporte.fecha_2;
				}else{
					route += "/garantiadepartamento/"+evt.id + '/' + reporte.fecha_1 + "/" + reporte.fecha_2;
				}
				break;
			case 4: 


				break;
		}

		if(route !== "/reporte"){

		api().get(route)
        .then(function(response)
        {
            self.setState({
                data : response.data
            });
            // console.log(response.data)
        });
    	}

	}
	formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}


	render(){
		// console.log('data-->',this.state);

		let {reporte,categorias} = this.state;
		let show = false;
		let etiqueta_filtro_2 = '';
		let opciones_filtro2 = '';
		let title = "";
		let key = '';
		let grafica = false;
		let PDF =false;
		let etiqueta="Fecha de Inicio:";
		if(reporte.reporte_id === 7){
			etiqueta = "Fecha:";
		}
		switch(reporte.reporte_id){
			case 1:
				show = true;
				title = "Produccion individual ";
				key ="total";
				grafica = true;
				break;
			case 2:
				title = "Utilidad por departamento";
				show = true;
				key ="total";
				grafica = true;
				break;
			case 3: 
				title = "Garantias";
				key="Garantias";
				grafica = true;
				break;
			case 4: 
				title = 'cumplimiento de citas';
				key = "Total";
				grafica = false;
				break;
				case 5: 
				PDF=true;
				
				grafica = false;
				break;

			default:
				show = false;
		}

	let reportes = [
	{label : 'Participaciones Contpaq' , value: 9},
	{label : 'Produccion individual' , value : 1},
	{label : 'Produccion por departamento', value : 2},
	{label : 'Reporte de garantias', value : 3},
	{label : 'Reporte de cumplimiento de citas' , value: 4},
	{label : 'Reporte de Comisiones' , value: 5},
	{label : 'Ventas Especiales' , value: 6},
	{label : 'Corte del dia' , value: 7},
	{label : 'Ticket sin PV' , value: 8},
	{label : 'Reporte Categoria' , value: 10},
	{label : 'Balance General' , value: 11},
	{label : 'Reporte Comisiones General' , value: 12},
	{label : 'Reporte Ticket Cancelados' , value: 13},
	{label : 'Reporte Ticket No Aprobados' , value: 14},

];
reportes.push({label : 'Reporte de Distribucion de participaciones' , value: 15})
reportes.push({label : 'Reporte Tickets General' , value: 16})
reportes.push({label : 'Reporte Produccion por Validar' , value: 17})


		 
	     
	   

		return(
			<div className="view">
				<div className="view-header">
					<header className="title text-white">
						<h1 className="h4 text-uppercase">Reportes</h1>

						
					</header>
				</div>
				<div className="view-content view-components">
					<Card className="mb-4">
						<CardBlock>

							<div className="row mb-3">
								<div className="text-left col-sm-3">
									<label>Reporte </label>
									<Select
										name='reporte_id'
										options={reportes}
										value={parseInt(reporte.reporte_id)}
										onChange={ (select) => { this.handleSelectChange(select, 'reporte_id') } }
									/>
								</div>
								{
									( parseInt(reporte.reporte_id) === 9||parseInt(reporte.reporte_id) === 10  ) &&
								<div className="text-left col-sm-3">
									<label>Mes</label>
									<Select
										name='mes'
										options={meses}
										value={parseInt(reporte.mes)}
										onChange={ (select) => { this.handleSelectChange(select, 'mes') } }
									/>
								</div>
							    }
							    {
									( parseInt(reporte.reporte_id) === 9 ||parseInt(reporte.reporte_id) === 10  ) &&
								<div className="text-left col-sm-3">
									<label>Año</label>
									<Select
										name='anos'
										options={anos}
										value={parseInt(reporte.ano)}
										onChange={ (select) => { this.handleSelectChange(select, 'ano') } }
									/>
								</div>
							    }
							    
								{
									( parseInt(reporte.reporte_id) !== 17&&parseInt(reporte.reporte_id) !== 16&&parseInt(reporte.reporte_id) !== 15&& parseInt(reporte.reporte_id) !== 14&& parseInt(reporte.reporte_id) !== 13&& parseInt(reporte.reporte_id) !== 9 &&parseInt(reporte.reporte_id) !== 10 &&parseInt(reporte.reporte_id) !== 11&&parseInt(reporte.reporte_id) !== 12) &&
								<div className="col-sm-2">
									<div className="form-group">
										<label className>{etiqueta}</label>
										<input
											type="date" 
											className="form-control"
											name="fecha_1"
											value={reporte.fecha_1 || ''}
											onChange={this.handleInputChange}
										/>
									</div>
								</div>
							    }
							   
								{
									( parseInt(reporte.reporte_id) !== 17&&parseInt(reporte.reporte_id) !== 16&&parseInt(reporte.reporte_id) !== 15&& parseInt(reporte.reporte_id) !== 14&&parseInt(reporte.reporte_id) !== 13&& parseInt(reporte.reporte_id) !== 7 &&parseInt(reporte.reporte_id) !== 9 && parseInt(reporte.reporte_id) !== 10 &&parseInt(reporte.reporte_id) !== 11&&parseInt(reporte.reporte_id) !== 12) &&
									<div className="col-sm-2">
										<div className="form-group">
											<label className>Fecha Final:</label>
											<input
												type="date" 
												className="form-control"
												name="fecha_2"
												value={reporte.fecha_2 || ''}
												onChange={this.handleInputChange}
											/>
										</div>
									</div>
								}
								 {
									( parseInt(reporte.reporte_id) === 8) &&
								<div className="col-sm-2">
									<div className="form-group">
										<label className>Tipos de Ticket</label>
										<Select
											type="text"
											name="departamento_id"
											options={tipos}
											value={parseInt(this.state.reporte.tipo_id)}
											onChange={ (select) => { this.handleSelectChange(select, 'tipo_id') } }
											clearable={false}
										/>
									</div>
								</div>
							    }
							    { ( parseInt(reporte.reporte_id) !== 17&&parseInt(reporte.reporte_id) !== 16&& parseInt(reporte.reporte_id) !== 15&&parseInt(reporte.reporte_id) !== 14&& parseInt(reporte.reporte_id) !== 13&&parseInt(reporte.reporte_id) !== 11&&parseInt(reporte.reporte_id) !== 12) &&
							    	<div className="col-sm-2 text-right">
										<label><br/></label><br/>
										<Button color='success' onClick={this.search}> <Fasearch/> </Button>
								    </div>
							    }
								
							</div>
							{((parseInt( reporte.reporte_id) === 1)||(parseInt( reporte.reporte_id) === 5)||(parseInt( reporte.reporte_id) === 6)) &&
							<div className="row mb-3">
								<div className="col-sm-4"> 
									<div className="form-group">
										<label className>Tecnicos:</label>
										<Select
											type="text"
											name="departamento_id"
											options={this.state.usuarios}
											value={parseInt(this.state.reporte.user_id)}
											onChange={ (select) => { this.handleSelectChange(select, 'user_id') } }
										/>
									</div>
								</div>
							</div>
						}
						{
									( parseInt(reporte.reporte_id) === 10 ) &&
									<div className="row mb-3">
								<div className="text-left col-sm-3">
									<label>Categoria</label>
									<Select
										name='categoria'
										options={categorias}
										value={parseInt(reporte.categoria)}
										onChange={ (select) => { this.handleSelectChange(select, 'categoria') } }
										clearable={false}
									/>
								</div>
								</div>
							    }




							
							<br/><br/><br/><br/><br/>
							<br/><br/><br/>
						</CardBlock>
					</Card>
					<Card style={{'flex': '3 0 0'}}>
					{
						grafica && 
						
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">{title}  <Button color="success" className="mx-4" onClick={this.search} >
                                Regresar
                            </Button></CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  
     								{
                                    (Object.keys(this.state.data).length === 0 ||reporte.reporte_id === 4||reporte.reporte_id === 3)?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>
                                  }

                                  <Legend />
                                  <Bar dataKey={key} fill='#406CBF' onClick={this.filter} minPointSize={1} />
                                  {
                                  	reporte.reporte_id === 1 && 
                                  	<Bar dataKey="meta" fill='green'  minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Cumplidas" fill='green' onClick={this.filter} minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Retardos" fill='orange' onClick={this.filter} minPointSize={1} />
                                  }
                                  {
                                  	reporte.reporte_id === 4 && 
                                  	<Bar dataKey="Retardos Criticos" fill='red' onClick={this.filter} minPointSize={1} />
                                  }
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                    
                }

                {
							reporte.reporte_id === 2 && 
						
                    <CardBlock>
                        <CardTitle className="text-uppercase h6">Produccion por Departamento  </CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />
                                  
     								{
                                    (Object.keys(this.state.data).length === 0 ||reporte.reporte_id === 4||reporte.reporte_id === 3)?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip/>}/>


                                  }

                                  <Legend />
                                  <Bar dataKey='Total Ventas' fill='#406CBF' onClick={this.filter} minPointSize={1} />
                                  
                                  
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                    
                }

                {
                	reporte.reporte_id===1&&
                	<CardBlock>
                        <CardTitle className="text-uppercase h6"> Proyección al Día</CardTitle>
                        <div className="small mb-4 card-subtitle"></div>
                        <div style={{width: '100%', height: '280px'}}>
                            <ResponsiveContainer>
                                <BarChart width={730} height={250} data={this.state.data}>
                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis />                                  
     							  {
                                    (Object.keys(this.state.data).length === 0)&& true?<Tooltip/>:
                                    <Tooltip content={<CustomTooltip2/>}/>


                                  }
                                  <Legend />                            
                                  <Bar dataKey="esperado" fill='green' onClick={this.filter} minPointSize={1} />
                                  <Bar dataKey="actual" fill='orange' onClick={this.filter} minPointSize={1} />
                                 </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </CardBlock>
                }
                {
                	(this.state.urlreporte!=="") &&
                	<ReporteComisiones 
                	datos={this.state.urlreporte}
                	fecha={this.state.reporte.fecha_1}  
                	id={this.state.reporte.user_id}/>
                }

                 {
                	(this.state.urlreporte2!=="") &&
                	<Ventas 
                	datos={this.state.urlreporte2}                	 
                	id={this.state.reporte.user_id}/>
                }
                {
                	this.state.routeEntrega !== "" &&
                	<EntregasDiarias
                		fecha={reporte.fecha_1}
                	/>
                }

                {
                	(this.state.reporte.reporte_id == 9 && this.state.reporte_contpaq !== "") &&
                	<ParticipacionesContpaq ruta={this.state.reporte_contpaq} mes={this.state.reporte.mes} ano={this.state.reporte.ano}/>
                }
                 {
                	(this.state.reporte.reporte_id == 1 && typeof this.state.data[0] !== 'undefined') &&
                	<Lista_tickets  lista={this.state.data[0].tickets}  data={this.state.data[0]} />
                }
                
                {
                	this.state.routesinpv !== "" &&
                	<Sinpv
                		datos={this.state.routesinpv} 
                	/>
                }
                {
                	(this.state.reporte.reporte_id == 4&& this.state.urlcumplimiento !== "") &&
                	<CumplimientoCitas
                		grafica={this.state.data.grafica} 
                		tecnicos={this.state.data.tecnicos} 
                	/>
                }
                {
                	(this.state.reporte.reporte_id == 10 && this.state.urlcategoria !== "") &&
                	<Utilidadcategoria  listado={this.state.data} mes={this.state.reporte.mes} ano={this.state.reporte.ano} categoria={this.state.reporte.categoria} />
                } 
                 {
                	(this.state.reporte.reporte_id == 11 ) &&
                	<BanlanceGeneral   />
                }
                 {
                	(this.state.reporte.reporte_id == 12 ) &&
                	<ReporteComiosionesGeneral   />
                }
                {
                	(this.state.reporte.reporte_id == 13 ) &&
                	<TicketsCancelados   />
                }
                 {
                	(this.state.reporte.reporte_id == 14 ) &&
                	<TicketsNoAprobados   />
                }
                {
                	(this.state.reporte.reporte_id == 15 ) &&
                	<DistribucionParticipaciones   />
                }
                {
                	(this.state.reporte.reporte_id == 16 ) &&
                	<TicketsGeneral   />
                }
                {
                	(this.state.reporte.reporte_id == 17 ) &&
                	<Reporteproduccion   />
                }

                </Card>
				</div>	
			</div>
			)
	}
}
function mapStateToProps(state, ownProps) {
    return {
        user : state.user,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(Reportes)



// WEBPACK FOOTER //
// ./src/views/reportes/index.js